module.exports = __webpack_public_path__ + "static/media/instagram-hover.5fca4530.svg";